import React from "react";
import Fade from "react-reveal/Fade";
// Comps
// Css
import classes from "./Content.module.scss";

const Content: React.FC = () => {
  return (
    <>
      <Fade top>
        <h2 className={classes.title}>story</h2>
      </Fade>
      <p className={classes.desc}>
        The year is 1932. The place is pre -WWII Germany. In Secret Hitler ,
        players are German politicians attempting to hold a fragile Liberal
        government together and stem the rising tide of Fascism. Watch out
        though—there are secret Fascists among you, and one player is Secret
        Hitler. Aim of the game is to find Secret Hitler and stop him! Players
        are secretly divided into two teams: Fascists, hidden to everyone but
        each other, and Liberals. If the Liberals can learn to trust each other,
        they can work together to gain enough votes and win the elections.
        However, the Fascists will do whatever it takes to steal power, win the
        elections and take over the country. You can play Secret Hitler face to
        face with your friends. For your convenience, only one device is
        required and no installations are needed to play.
      </p>
    </>
  );
};

export default Content;
